import { HttpError } from '../services/api'

type ErrorShape = { error?: unknown; message?: unknown }

export const toErrorMessage = (e: unknown, fallback = 'Unexpected error') => {
	// If it's our HttpError, prefer the parsed body `error` or `message` fields
	if (e instanceof HttpError) {
		const err = e as HttpError
		const body = err.body as unknown
		if (body && typeof body === 'object') {
			const b = body as ErrorShape
			if (typeof b.error === 'string' && b.error.trim()) return b.error
			if (typeof b.message === 'string' && b.message.trim()) return b.message
		}
		// fall back to its message
		return err.message || fallback
	}

	// Generic Error object
	if (e instanceof Error) return e.message

	// If someone threw an object with { error } or { message }
	if (typeof e === 'object' && e !== null) {
		const b = e as ErrorShape
		if (typeof b.error === 'string' && b.error.trim()) return b.error
		if (typeof b.message === 'string' && b.message.trim()) return b.message
	}

	if (typeof e === 'string') return e
	return fallback
}
